import { IonIcon, IonLabel } from '@ionic/react'
import React from 'react'
import { ISearchToolbarFormItemProps } from './search-toolbar-form-item-props.interface'
import './search-toolbar-form-item.scss'

const SearchToolbarFormItem: React.FC<ISearchToolbarFormItemProps> = ({ label, icon, children }) => {
  return (
    <div className="edisu-search-toolbar-form-item">
      <IonLabel className="edisu-label">{label}</IonLabel>
      <div className="bottom">
        {children}
        {icon && (icon.icon || icon.src) && <IonIcon className="search-toolbar-icon" {...icon} />}
      </div>
    </div>
  )
}

export default SearchToolbarFormItem
